export const iconFontAwesomeTravelHotelPaperPlane = (
	<i className="fa-solid fa-paper-plane"></i>
);
